import { createTheme } from '../utils/create-theme';

// Create default global light theme
const {
  Provider,
  Consumer,
  useTheme
} = createTheme(() => ({
  mode: 'light'
}));
export { useTheme as useGlobalTheme };
export default {
  Provider,
  Consumer
};